import fetch from '../utils/fetch-json';
import { DID_VERIFY_IDENTITY, FAILED_TO_VERIFY_IDENTITY, STARTED_TO_VERIFY_IDENTITY } from '../constants/index';
import { showErrorModal } from '../global-message/global-message-actions';

export const startVerificationWithBankID =
    (redirectUrl) =>
    ({ dispatch, getState }) => {
        const state = getState();

        let fullUrl = `${state.baseURL}/api/private/user/verification/sb1/bankid`;

        return fetch({
            url: fullUrl,
            options: {
                method: 'PUT',
                body: {
                    redirectUrl,
                },
            },
            dispatch,
            getState,
        })
            .then((response) => Promise.resolve(response.body.url))
            .catch(() =>
                Promise.reject(
                    dispatch(
                        showErrorModal(
                            'Noe gikk galt ved verifiseringen med BankID. Prøv igjen senere, eller ta kontakt med oss via snakkeboblen og beskriv problemet.'
                        )
                    )
                )
            );
    };

export const verifySB1BankId =
    ({ code, state }) =>
    async ({ dispatch, getState }) => {
        const fullUrl = getState().baseURL.concat(`/api/private/user/verification/sb1/bank-id`);

        try {
            dispatch({ type: STARTED_TO_VERIFY_IDENTITY });
            const response = await fetch({
                options: {
                    method: 'POST',
                    body: {
                        code,
                        state,
                    },
                },
                url: fullUrl,
                dispatch,
                getState,
            });
            dispatch({ type: DID_VERIFY_IDENTITY });
            return response.body;
        } catch (e) {
            dispatch({ type: FAILED_TO_VERIFY_IDENTITY });
            if (e.body?.errors?.global) {
                dispatch(showErrorModal(e.body.errors.global));
            } else {
                dispatch(
                    showErrorModal(
                        'Noe feilet med håndteringen av BankID. Prøv igjen senere, eller ta kontakt med oss via chatteboblen og beskriv problemet.'
                    )
                );
            }

            return Promise.reject(e.body);
        }
    };

export const startReceiverAccountNumberConfirmation =
    ({ accountNumber, invitationId, redirectURI }) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = state.baseURL.concat('/api/private/user/verification/sb1/receiver-account-number');

        return fetch({
            url: fullUrl,
            options: {
                method: 'PUT',
                body: {
                    account_number: accountNumber,
                    invitationId,
                    redirectURI,
                },
            },
            dispatch,
            getState,
        })
            .then((response) => Promise.resolve(response.body.url))
            .catch(() => {
                return Promise.reject(
                    dispatch(
                        showErrorModal(
                            'Noe gikk galt under lagring av kontonummer. Prøv igjen senere, eller ta kontakt med oss via chatteboblen og beskriv problemet.'
                        )
                    )
                );
            });
    };

export const startAccountNumberConfirmation =
    (accountNumber) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = state.baseURL.concat('/api/private/user/verification/sb1/account-number');

        return fetch({
            url: fullUrl,
            options: {
                method: 'PUT',
                body: {
                    account_number: accountNumber,
                },
            },
            dispatch,
            getState,
        })
            .then((response) => Promise.resolve(response.body.url))
            .catch(() => {
                return Promise.reject(
                    dispatch(
                        showErrorModal(
                            'Noe gikk galt under lagring av kontonummer. Prøv igjen senere, eller ta kontakt med oss via chatteboblen og beskriv problemet.'
                        )
                    )
                );
            });
    };

export const startEmailChangeVerification =
    ({ newEmail, redirectUrl }) =>
    ({ dispatch, getState }) => {
        const state = getState();

        const fullUrl = `${state.baseURL}/api/private/user/verification/sb1/email`;

        return fetch({
            url: fullUrl,
            options: {
                method: 'PUT',
                body: {
                    newEmail,
                    redirectUrl,
                },
            },
            dispatch,
            getState,
        })
            .then((response) => Promise.resolve(response.body.url))
            .catch(() =>
                Promise.reject(
                    dispatch(
                        showErrorModal(
                            'Noe gikk galt med BankID-verifiseringen. Prøv igjen senere, eller ta kontakt med oss via snakkeboblen og beskriv problemet.'
                        )
                    )
                )
            );
    };

export const startVerificationForStoringGiverDataConsent =
    ({ organizationId }) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = state.baseURL.concat(
            `/api/public/organization/${organizationId}/store-giver-data-setup/start-verification-sb1`
        );

        return fetch({
            url: fullUrl,
            options: {
                method: 'POST',
            },
            dispatch,
            getState,
        })
            .then((response) => response.body.url)
            .catch(() =>
                dispatch(
                    showErrorModal(
                        'Noe gikk galt ved verifisering med BankID. Prøv igjen senere, eller ta kontakt med oss via snakkeboblen og beskriv problemet.'
                    )
                )
            );
    };

export const verifyGiverDataConsent =
    ({ organizationId, code, session_state, state }) =>
    async ({ dispatch, getState }) => {
        const reduxState = getState();
        const fullUrl = reduxState.baseURL.concat(
            `/api/public/organization/${organizationId}/store-giver-data-setup/sb1`
        );

        try {
            const response = await fetch({
                options: {
                    method: 'POST',
                    body: {
                        code,
                        session_state,
                        state,
                    },
                },
                url: fullUrl,
                dispatch,
                getState,
            });

            return response.body;
        } catch (e) {
            if (e.status === 500 && e?.body?.errors?.global) {
                dispatch(showErrorModal(e?.body?.errors?.global));
            } else {
                dispatch(
                    showErrorModal(
                        'Noe gikk galt. Prøv igjen senere, eller ta kontakt med oss via chatteboblen og beskriv problemet.'
                    )
                );
            }

            throw e;
        }
    };
